export default "__VITE_ASSET__B2e0QfBK__"